<code [innerHTML]="safeHTML">
</code>